import * as userActions from '../actions/userAction';
import * as configActions from '../actions/configAction';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as logisticsResourcesActions from '../actions/logisticsResourcesAction';
import * as auth from './auth';
import HttpService from './HttpService';
import HttpServiceLogin from './HttpServiceLogin';
import plantService from './PlantService';
import configurationService from './ConfigurationService';
import { checkOriginNonProd, configs, decodeToken, getApiKeyLogistics, getUrlConfigApi, getUrlSecurityApi } from '../utils/util';
import Dao from '../dao/Dao';
import ConnectionFactory from '../dao/ConnectionFactory';
import { ENUMS } from '../utils/constants';

const httpServiceConfig = new HttpService(getUrlConfigApi(window), getApiKeyLogistics(window));
const httpServiceSecurity = checkOriginNonProd(window) ? new HttpServiceLogin(getUrlSecurityApi(window)) : new HttpServiceLogin(getUrlConfigApi(window));

export default class SecurityService {
    static login(user, callback) {
        return (dispatch) => {
            const api = checkOriginNonProd(window) ? getUrlSecurityApi(window) : getUrlConfigApi(window);
            const callbackLogin = (tokenSmartSecurityGlobalSafe) => {
                const decoded = decodeToken(tokenSmartSecurityGlobalSafe.data.acesstoken);

                const userData = {
                    name: decoded.nameid,
                    userName: decoded.unique_name,
                    email: decoded.email,
                    token: tokenSmartSecurityGlobalSafe.data.acesstoken,
                    vision: decoded.CurrentVision,
                    resource: undefined,
                    visions: JSON.parse(decoded.VISIONS),
                    culture: localStorage.getItem('i18nextLng'),
                };

                ConnectionFactory
                    .getConnection()
                    .then((conexao) => new Dao(conexao, 'users'))
                    .then((dao) => {
                        userData.dataStatus = 'R';
                        dao.add(userData);
                        auth.login(userData, tokenSmartSecurityGlobalSafe.data.acesstoken);
                        dispatch(userActions.setUser(userData));
                        dispatch(this.loadConfigUser());
                        if (callback) {
                            callback(true);
                        }
                    });
            };

            httpServiceSecurity.instance.post(`${api}/security/login`, {
                userName: user.userName,
                password: user.password,
                culture: localStorage.getItem('i18nextLng'),
                systemId: 44,
            }).then((tokenSmartSecurityGlobalSafe) => {
                callbackLogin(tokenSmartSecurityGlobalSafe);
            }).catch((error) => {
                console.log(error);
                if (callback) {
                    callback(false);
                }
            });
        };
    }

    static refreshToken = (vision, callback) => {
        const httpServiceSmartScurity = checkOriginNonProd(window) ? new HttpService(getUrlSecurityApi(window)) : new HttpService(getUrlConfigApi(window));
        const uri = `/security/vision/${vision}/refreshtoken`;
        return (dispatch) => httpServiceSmartScurity.instance.post(uri, null).then((userResult) => {
            if (userResult) {
                const decoded = decodeToken(userResult.data.acesstoken);
                const user = {
                    name: decoded.nameid,
                    userName: decoded.unique_name,
                    email: decoded.email,
                    token: userResult.data.acesstoken,
                    vision: decoded.CurrentVision,
                    resource: undefined,
                    visions: JSON.parse(decoded.VISIONS),
                    culture: localStorage.getItem('i18nextLng')
                };
                auth.login(user, user.token);
                dispatch(userActions.setUser(user));
                dispatch(this.loadConfigUser());

                if (callback) {
                    callback(user);
                }
                return user;
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    static validadeToken = () => {
        return auth.validadeToken();
    };

    static loadConfigUser = () => {
        return (dispatch) => {
            dispatch(configurationService.getConfigs({ moduleId: ENUMS.eModules.User.value }, (response) => {
                if (response && response.items?.length > 0) {
                    const config = configs(ENUMS.eModules.User.value, response.items);
                    console.log("loadConfigUser", config);
                    dispatch(userActions.setShedConfig(config.shed, {}))
                    dispatch(userActions.setDockConfig(config.dock, {}))
                    dispatch(userActions.setResourceConfig(config.resource, {}))
                    dispatch(userActions.setResourceLaserConfig(config.resourceLaser))
                    dispatch(userActions.setEquipmentConfig(config.equipment, {}))
                    dispatch(userActions.setUnitConfig(config.unitId, {}))

                    //Tipo Impressão Click/Logistics ou não imprimir
                    dispatch(userActions.setTypePrintConfig(config.print))

                }
            }))
        }
    };

    static isAuthenticated = () => {
        return (dispatch) => {
            return auth.isAuthenticated(() => {
                const user = auth.getUser();
                dispatch(userActions.setUser(user));
            });
        };
    };

    static loadConfig(vision, moduleId) {
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(plantService.searchSheds(vision));
                httpServiceConfig.instance.get(`/config`, { params: { moduleId: moduleId } }).then((configResult) => {
                    const dados = configResult.data.data;
                    dados.vision = vision;
                    dados.dataStatus = 'R';
                    dispatch(configActions.update(dados));
                }).catch(() => {
                    dispatch(configActions.reset());
                });
            }
        };
    }

    static loadUser(callback) {
        return (dispatch) => {
            const user = auth.getUser();
            dispatch(userActions.setUser(user));
            dispatch(userActions.getUser());
            if (callback) {
                callback()
            }
        };
    }

    static setVision(vision, callback) {
        return (dispatch) => {
            dispatch(startLoading());
            if (navigator.onLine) {
                if (vision !== undefined && vision !== '') {
                    auth.refreshToken(vision, (user) => dispatch(userActions.setUser(user))).then(() => {
                        const url = '/resource/all';
                        return httpServiceConfig.instance.get(url).then((result) => {
                            ConnectionFactory
                                .getConnection()
                                .then((conexao) => new Dao(conexao, 'resources'))
                                .then((dao) => {
                                    const dados = result.data.data.items;
                                    dados.forEach((data) => {
                                        data.vision = vision;
                                        data.dataStatus = 'R';
                                        dao.add(data);
                                    });

                                    dispatch(endLoading());
                                    dispatch(userActions.setVision(vision));
                                    dispatch(logisticsResourcesActions.setResources(dados));
                                    if (callback) {
                                        callback({ success: true, message: '' });
                                    }
                                });
                        }).catch((error) => {
                            dispatch(endLoading());
                            dispatch(logisticsResourcesActions.setResources([]));
                            if (callback) {
                                callback({ success: false, message: error });
                            }
                        });
                    });
                } else {
                    dispatch(endLoading());
                    dispatch(userActions.setVision(vision));
                    dispatch(logisticsResourcesActions.setResources([]));
                }
            }
        };
    }

    static setCulture(culture) {
        return (dispatch) => { dispatch(userActions.setCulture(culture)); };
    }

    static setWarehouse(warehouse) {
        return (dispatch) => { dispatch(userActions.setWarehouse(warehouse)); };
    }

    static setResource(resource, resourceObj) {
        return (dispatch) => { dispatch(userActions.setResource(resource, resourceObj)); };
    }

    static setResourceLaser(resource) {
        return (dispatch) => { dispatch(userActions.setResourceLaser(resource)); };
    }

    static setDock(dock, dockObj) {
        return (dispatch) => { dispatch(userActions.setDock(dock, dockObj)); };
    }

    static setShed(shed, shedObj) {
        return (dispatch) => { dispatch(userActions.setShed(shed, shedObj)); };
    }

    static setPrinter(printer) {
        return (dispatch) => { dispatch(userActions.setPrinter(printer)); };
    }

    static setEquipment(equipment, equipmentObj) {
        return (dispatch) => { dispatch(userActions.setEquipment(equipment, equipmentObj)); };
    }

    static checkPermission(permission) {
        return auth.checkPermission(permission);
    }
}